import Vue from 'vue'

// 自定义指令
import directive from '@/directive/permission/index'
Vue.use(directive)
